import React from 'react';

export const MiniCheck = ({ checked, onChange, label, color = '#047857' }) => (
  <label className="filter-pill" style={{ display: 'flex', alignItems: 'center', gap: 3, cursor: 'pointer', padding: '2px 4px', fontSize: '0.58rem', lineHeight: 1.2, color: checked ? color : '#555', borderRadius: 4 }}>
    <input type="checkbox" checked={checked} onChange={onChange}
      style={{ width: 10, height: 10, accentColor: color, margin: 0, cursor: 'pointer' }} />
    <span style={{ fontWeight: checked ? 600 : 400 }}>{label}</span>
  </label>
);

export const MiniNum = ({ value, onChange, min = 0, max = 50000, width = 42 }) => (
  <input type="number" value={value} min={min} max={max}
    className="word-count-input"
    onChange={e => onChange(parseInt(e.target.value) || 0)}
    style={{ width, background: 'rgba(253, 230, 138,0.08)', border: '1px solid rgba(253, 230, 138,0.2)', color: '#38bdf8', padding: '2px 4px', borderRadius: 4, fontSize: '0.55rem', textAlign: 'right' }} />
);
